<template>
  <ReportToolBelt__Edit v-if="type === 'edit'" />
</template>

<script>
import ReportToolBelt__Edit from "@/components/Reports/ToolBelts/Edit.vue";
import {ReportData} from "@/store/report/ReportData";

export default {
  name: "ReportToolBelt",
  components: { ReportToolBelt__Edit },
  props: ['type'],
  computed: {
    report_data: {
      get() {
        return ReportData().get()
      },
      set(value) {
        ReportData().set(value)
      }
    }
  }
}
</script>

<style scoped>

</style>